<template>
  <div class="m-card-primary m-the-modal-content m-the-modal-allowed-url">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="$modal.closeModal"
    >
      <header class="m-the-modal-header">
        <h5>{{ $t('mContentEditorModalAllowedUrl.title') }}</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section class="m-the-modal-section-allowed-url">
        <div class="m-container-primary">
          <div class="row">
            <div class="column column-6">
              <!-- youtube -->
              <div class="url-category-header url-category-header-youtube margin-top-medium">
                <i class="fab fa-youtube"></i>
                <span>{{ $t(`mContentEditorModalAllowedUrl.youtube.title`) }}</span>
              </div>
              <div class="url-category-list url-category-list-youtube font-size-small">
                <ul>
                  <li><i class="far fa-check-circle"></i> {{ $t(`mContentEditorModalAllowedUrl.youtube.list.url1`) }}</li>
                  <li><i class="far fa-check-circle"></i> {{ $t(`mContentEditorModalAllowedUrl.youtube.list.url2`) }}</li>
                  <li><i class="far fa-check-circle"></i> {{ $t(`mContentEditorModalAllowedUrl.youtube.list.url3`) }}</li>
                </ul>
              </div>
            </div>
            <div class="column column-6">
              <!-- bunny -->
              <div class="url-category-header url-category-header-bunny margin-top-medium">
                <i class="fas fa-rabbit-fast"></i>
                <span>{{ $t(`mContentEditorModalAllowedUrl.bunny.title`) }}</span>
              </div>
              <div class="url-category-list url-category-list-bunny font-size-small">
                <ul>
                  <li><i class="far fa-check-circle"></i> {{ $t(`mContentEditorModalAllowedUrl.bunny.list.url1`) }}</li>
                  <li><i class="far fa-check-circle"></i> {{ $t(`mContentEditorModalAllowedUrl.bunny.list.url2`) }}</li>
                  <li><i class="far fa-check-circle"></i> {{ $t(`mContentEditorModalAllowedUrl.bunny.list.url3`) }}</li>
                </ul>
              </div>
            </div>
          </div> <!-- row close -->

          <div class="row">
            <div class="column column-6">
              <!-- vimeo -->
              <div class="url-category-header url-category-header-vimeo margin-top-medium">
                <i class="fab fa-vimeo"></i>
                <span>{{ $t(`mContentEditorModalAllowedUrl.vimeo.title`) }}</span>
              </div>
              <div class="url-category-list url-category-list-vimeo font-size-small">
                <ul>
                  <li><i class="far fa-check-circle"></i> {{ $t(`mContentEditorModalAllowedUrl.vimeo.list.url1`) }}</li>
                  <li><i class="far fa-check-circle"></i> {{ $t(`mContentEditorModalAllowedUrl.vimeo.list.url2`) }}</li>
                  <li><i class="far fa-check-circle"></i> {{ $t(`mContentEditorModalAllowedUrl.vimeo.list.url3`) }}</li>
                  <li><i class="far fa-check-circle"></i> {{ $t(`mContentEditorModalAllowedUrl.vimeo.list.url4`) }}</li>
                  <li><i class="far fa-check-circle"></i> {{ $t(`mContentEditorModalAllowedUrl.vimeo.list.url5`) }}</li>
                  <li><i class="far fa-check-circle"></i> {{ $t(`mContentEditorModalAllowedUrl.vimeo.list.url6`) }}</li>
                  <li><i class="far fa-check-circle"></i> {{ $t(`mContentEditorModalAllowedUrl.vimeo.list.url7`) }}</li>
                  <li><i class="far fa-check-circle"></i> {{ $t(`mContentEditorModalAllowedUrl.vimeo.list.url8`) }}</li>
                </ul>
              </div>
            </div>
            <div class="column column-6">
              <!-- amazon -->
              <div class="url-category-header url-category-header-amazon margin-top-medium">
                <i class="fab fa-amazon"></i>
                <span>{{ $t(`mContentEditorModalAllowedUrl.amazon.title`) }}</span>
              </div>
              <div class="url-category-list url-category-list-amazon font-size-small">
                <ul>
                  <li><i class="far fa-check-circle"></i> <span>{{ $t(`mContentEditorModalAllowedUrl.amazon.list.url1`) }} <small>({{ $t(`mContentEditorModalAllowedUrl.amazon.description`) }})</small></span></li>
                </ul>
              </div>
              <!-- canva -->
              <div class="url-category-header url-category-header-canva margin-top-large">
                <i class="fas fa-copyright"></i>
                <span>{{ $t(`mContentEditorModalAllowedUrl.canva.title`) }}</span>
              </div>
              <div class="url-category-list url-category-list-canva font-size-small">
                <ul>
                  <li><i class="far fa-check-circle"></i> {{ $t(`mContentEditorModalAllowedUrl.canva.list.url1`) }}</li>
                  <li><i class="far fa-check-circle"></i> {{ $t(`mContentEditorModalAllowedUrl.canva.list.url2`) }}</li>
                </ul>
              </div>
            </div>
          </div> <!-- row close -->

        </div> <!-- container close -->

      </section>
      <footer class="m-the-modal-footer">
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>
export default {
  name: 'MoleculeContentEditorModalAllowedUrl',

  data () {
    return {
      buttonPrimary: {
        action: 'ENTENDIDO',
        class: 'a-button-assets-primary',
        sending: false,
        type: 'submit'
      }
    }
  }
}
</script>
